import { callFunction } from '@/lib/api';

/**
 * Audited CPR reveal for the on-screen preview and the PDF only.
 * The plaintext is kept in memory by the caller and must not be written
 * onto a template or report row.
 */
export async function revealReportCpr(patientId: string): Promise<string> {
  const result = await callFunction<
    { patient_id: string; source: string; purpose: string },
    { cpr: string }
  >('decrypt-cpr', {
    patient_id: patientId,
    source: 'patient-report',
    purpose: 'Forhåndsvisning og PDF af patientrapport',
  });
  return result.cpr;
}
